export var ENTITY = "template";
export var REDUCER_KEY = "TEMPLATE_V2";
export var BASE_PATH_ENTITY = "templates";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    defaultSort: [
        { field: "modifiedAt", method: "DESC" },
        { field: "createdAt", method: "DESC" },
    ],
};
